export const StatCard = ({ label, value, icon: Icon, tone = "bg-emerald-50 text-emerald-800", testId }) => (
  <div className="rounded-3xl bg-white border border-emerald-900/10 p-5 card-hover" data-testid={testId}>
    <div className="flex items-center justify-between">
      <p className="text-sm text-slate-500">{label}</p>
      <div className={`h-9 w-9 rounded-xl flex items-center justify-center ${tone}`}><Icon size={16} /></div>
    </div>
    <p className="mt-3 text-2xl font-extrabold tracking-tight text-emerald-950" data-testid={testId ? `${testId}-value` : undefined}>{value}</p>
  </div>
);
